import { APIService } from "../apiService";
import { AuthenticationService } from "../authenticationService";
import {
  ReceivingDiscrepancy,
  GetPurchaseOrderReceivingDiscrepancyQueryParams,
  PatchPurchaseOrderReceivingDiscrepancyRequestBody
} from "src/types";

class ActiveAntsReceivingDiscrepancyAPIService extends APIService {
  constructor(authenticationService: AuthenticationService) {
    super(authenticationService, "/v1/active-ants-purchase-orders");
  }

  async getActiveAntsReceivingDiscrepancyById(
    activeAntsPurchaseOrderId: string,
    queryParams?: GetPurchaseOrderReceivingDiscrepancyQueryParams
  ): Promise<ReceivingDiscrepancy> {
    const pathParam = encodeURIComponent(activeAntsPurchaseOrderId);
    return await this.jwtRequest("GET", `/${pathParam}/receiving-discrepancy`, undefined, queryParams);
  }

  async patchActiveAntsReceivingDiscrepancyResolution(
    activeAntsPurchaseOrderId: string,
    requestBody: PatchPurchaseOrderReceivingDiscrepancyRequestBody
  ): Promise<ReceivingDiscrepancy> {
    const pathParam = encodeURIComponent(activeAntsPurchaseOrderId);
    return await this.jwtRequest("PATCH", `/${pathParam}/receiving-discrepancy/resolution`, requestBody);
  }
}

export { ActiveAntsReceivingDiscrepancyAPIService };
